export async function selectFile(opts?: { accept?: string }): Promise<File | null> {
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = opts?.accept ?? '*/*'

    const openFileDialog = () =>
        new Promise<File | null>((resolve) => {
            input.addEventListener('cancel', () => resolve(null))
            input.addEventListener('change', () => {
                const file = input.files?.[0]
                if (!file) {
                    resolve(null)
                    return
                }
                resolve(file)
            })
            input.click()
        })

    try {
        return await openFileDialog()
    } finally {
        input.remove()
    }
}
